module.exports = __webpack_public_path__ + "static/img/kangfang.1027c71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doctor/kangfang.png
// module id = 1HcT
// module chunks = 1